import React from 'react'
import Heroes from '../components/landing/heroes/Heroes'
import ProductOverview from '../components/landing/productoverview/ProductOverview'
import Slider from '../components/landing/slider/Slider'
import HowItWorks from '../components/landing/howitworks/HowItWorks'
import UniqueFeature from '../components/landing/uniquefeature/UniqueFeature'
import UserFeedback from '../components/landing/feedback/UserFeedback'
import Pricing from '../components/landing/pricing/Pricing'
import { FaQ } from 'react-icons/fa6'

const Landing = () => {
  return (
    <>

    <Heroes />
      <ProductOverview />
      <Slider />
      <HowItWorks />
      <UniqueFeature />
      <UserFeedback />
      <Pricing />
      <FaQ />
      
    </>
  )
}

export default Landing
